import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { statusTone, textOf } from "@/design-system/dna/status"

const badgeVariants = cva(
  "dna-ds-badge inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  const tone = props["data-tone"] || statusTone(textOf(props.children).trim())
  return (<div data-tone={tone || undefined} className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
